import { FileText } from 'lucide-react';
import { NodeShell } from './NodeShell.tsx';
import { colors } from '../../../config/design-tokens.ts';
import type { PKGNodeComponentProps } from './DecisionNode.tsx';

export function RequirementNode({ data, isConnectable }: PKGNodeComponentProps) {
  return (
    <NodeShell
      testId="pkg-node-requirement"
      shape="square"
      accentColor={colors.graphite[600]}
      icon={FileText}
      label={data.summary ?? data.entityId}
      badge={data.badge}
      isConnectable={isConnectable}
    />
  );
}
